import { Box, Flex } from "@chakra-ui/layout";
import { Skeleton, Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { TiposDocilAnimal } from "core/features/animal/animal.data";
import { AnimalForm, TipoAnimal } from "core/features/animal/typings";
import moment from "moment";
import { Control, UseFormWatch } from "react-hook-form";
import ShadowSelectableButton from "ui/components/Button/ShadowSelectableButton";
import Field from "ui/components/Input/Field";
import InputFile from "ui/components/Input/InputFile";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import SelectCorAnimal from "./SelectCorAnimal";
import SelectPorteAnimal from "./SelectPorteAnimal";

interface FormPetProps {
  control: Control<AnimalForm, object>;
  watch: UseFormWatch<AnimalForm>;
  tiposAnimal: TipoAnimal[] | undefined;
}

function FormPet({ control, watch, tiposAnimal }: FormPetProps) {
  const form = watch();

  const cartaoVacina = form.cartaoVacina;
  const foto = form.foto;
  const tipoAnimalId = form.tipoAnimalId;

  return (
    <>
      <Box as={Row} mb={4}>
        <Field
          control={control}
          name="tipoAnimalId"
          rules={{ required: "Campo obrigatório" }}
          render={({ field }) => (
            <Row gutter={[16, 16]}>
              {tiposAnimal ? (
                tiposAnimal.map((t) => (
                  <Box as={Col} xs={6} key={t.id}>
                    <ShadowSelectableButton
                      selected={tipoAnimalId === t.id}
                      onClick={() => field.onChange(t.id)}
                      onUnselect={() => field.onChange(undefined)}
                    >
                      {t.nome}
                    </ShadowSelectableButton>
                  </Box>
                ))
              ) : (
                <>
                  <SkeletonCard />
                  <SkeletonCard />
                  <SkeletonCard />
                  <SkeletonCard />
                </>
              )}
            </Row>
          )}
        />
      </Box>

      <Box as={Row} mb={6} gutter={36}>
        <Box as={Col} xs={13}>
          <Field
            label="Nome"
            control={control}
            name="nome"
            rules={{ required: "Campo obrigatório" }}
          />
        </Box>

        <Box as={Col} xs={11}>
          <Field
            label="Porte"
            control={control}
            name="porte"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectPorteAnimal {...field} isInvalid={isInvalid} />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={36} mb={6}>
        <Box as={Col} xs={13}>
          <Box as={Row} gutter={18}>
            <Box as={Col} xs={12}>
              <Field
                label="Data de Nascimento"
                control={control}
                name="dataNascimento"
                inputProps={{
                  type: "date",
                  max: moment().format("YYYY-MM-DD"),
                }}
              />
            </Box>

            <Box as={Col} xs={12}>
              <Field
                label="Dócil?"
                control={control}
                name="docio"
                rules={{ required: "Campo obrigatório" }}
                render={({ field, isInvalid }) => (
                  <SelectBaseAntd
                    onChange={(v) =>
                      v === "1" ? field.onChange(1) : field.onChange(0)
                    }
                    value={
                      field.value === 1 || field.value === true
                        ? "1"
                        : field.value === 0 || field.value === false
                        ? "0"
                        : undefined
                    }
                    isInvalid={isInvalid}
                    options={TiposDocilAnimal}
                    size="large"
                  />
                )}
              />
            </Box>
          </Box>
        </Box>

        <Box as={Col} xs={11}>
          <Field
            label="Cor"
            control={control}
            name="cor"
            render={({ field, isInvalid }) => {
              return <SelectCorAnimal {...field} isInvalid={isInvalid} />;
            }}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={36} mb={6}>
        <Box as={Col} xs={24}>
          <Field
            label="Observação"
            control={control}
            name="observacao"
            inputProps={{
              placeholder: "Escreva a observação...",
            }}
          />
        </Box>
      </Box>

      <Flex mt={8} flexDir="column">
        <Text as="h3" mb={2} fontWeight="500" fontSize={18}>
          Arquivos
        </Text>
        <Box as={Row} gutter={16}>
          <Box as={Col} xs={9}>
            <Field
              label="Cartão de vacinação"
              control={control}
              name="cartaoVacina"
              render={({ field }) => (
                <InputFile
                  showPreview
                  label="Anexar vacinas"
                  value={field.value}
                  onChange={field.onChange}
                  accept="image/*"
                  name={
                    typeof cartaoVacina === "string"
                      ? cartaoVacina.split("/").pop()
                      : cartaoVacina?.name
                  }
                />
              )}
            />
          </Box>
          <Box as={Col} xs={9}>
            <Field
              label="Foto"
              control={control}
              name="foto"
              render={({ field }) => (
                <InputFile
                  showPreview
                  label="Anexar foto"
                  value={field.value}
                  onChange={field.onChange}
                  accept="image/*"
                  name={
                    typeof foto === "string"
                      ? foto.split("/").pop()
                      : foto?.name
                  }
                />
              )}
            />
          </Box>
        </Box>
      </Flex>
    </>
  );
}

const SkeletonCard = () => (
  <Box as={Col} xs={6}>
    <Skeleton w="100%" py={12} rounded={16} />
  </Box>
);

export default FormPet;
